import { Injectable, Injector } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(public injector: Injector) {}

  showSuccessToast(header: string, message: string, key: string = undefined) {
    this.showToast('success', header, message, key);
  }

  showErrorToast(header: string, message: string, key: string = undefined) {
    this.showToast('error', header, message, key);
  }

  showWarnToast(header: string, message: string, key: string = undefined) {
    this.showToast('warn', header, message, key);
  }

  private showToast(severity, summary, detail, key: string = undefined) {
    const messageService = this.injector.get(MessageService);
    if (key != undefined) {
      messageService.add({
        key: key,
        severity: severity,
        summary: summary,
        detail: detail,
      });
    } else {
      messageService.add({
        severity: severity,
        summary: summary,
        detail: detail,
      });
    }
  }
}
